import { API_URL } from '../../../../constants/urls.constants';
import { appServiceApi } from '../../../apis/app-service.api';
import { APP_API_TAGS } from '../../../app.constants';
import type {
  AiCreditsResponse,
  AiCreditsSummaryResponse,
  ApplicationTrendsParams,
  ApplicationTrendsResponse,
  RecruitmentStatsResponse,
} from './recruitment-dashboard.type';

const { RECRUITMENT_DASHBOARD } = APP_API_TAGS;

export const recruitmentDashboardApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET: Recruitment summary stats (total applicants, screening, interviews, active jobs)
    getRecruitmentStats: builder.query<RecruitmentStatsResponse, void>({
      query: () => ({
        url: API_URL.recruitmentDashboardStats,
        method: 'GET',
      }),
      providesTags: [RECRUITMENT_DASHBOARD],
    }),

    // GET: Monthly shortlisted vs hired application trends
    getApplicationTrends: builder.query<
      ApplicationTrendsResponse,
      ApplicationTrendsParams
    >({
      query: (params) => ({
        url: API_URL.recruitmentApplicationTrends,
        method: 'GET',
        params,
      }),
      providesTags: [RECRUITMENT_DASHBOARD],
    }),
    // GET: Daily shortlisted vs hired application trends
    getDailyApplicantsTrends: builder.query<
      ApplicationTrendsResponse,
      ApplicationTrendsParams
    >({
      query: (params) => ({
        url: API_URL.recruitmentDailyApplicationTrends,
        method: 'GET',
        params,
      }),
      providesTags: [RECRUITMENT_DASHBOARD],
    }),

    // GET: AI credits usage for an organization
    getAICredits: builder.query<AiCreditsResponse, string>({
      query: (organizationId) => ({
        url: `${API_URL.aiCredits}/${organizationId}`,
        method: 'GET',
      }),
      providesTags: [RECRUITMENT_DASHBOARD],
    }),

    // GET: AI credits summary (aggregated per feature type) for an organization
    getAICreditsSummary: builder.query<AiCreditsSummaryResponse, string>({
      query: (organizationId) => ({
        url: `${API_URL.aiCreditsSummary}/${organizationId}/summary`,
        method: 'GET',
      }),
      providesTags: [RECRUITMENT_DASHBOARD],
    }),
  }),
});

export const {
  useGetRecruitmentStatsQuery,
  useGetApplicationTrendsQuery,
  useGetDailyApplicantsTrendsQuery,
  useGetAICreditsQuery,
  useGetAICreditsSummaryQuery,
} = recruitmentDashboardApi;
